import React from "react";
import Tooltip from '@mui/material/Tooltip';
class DefaultTooltip extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Tooltip title={this.props.title} placement="top" arrow color="tooltip" slotProps={{
          tooltip: {
            sx: {
              color: "#ffffff",
              backgroundColor: "#1A206C",
            },
          },
          arrow: {
            sx: {
              "&::before": {
                backgroundColor: "#1A206C",
              }
            }
          },
        }}
      >
        {this.props.children}
       </Tooltip>
    );
  }
}

export default DefaultTooltip;
